import { render, staticRenderFns } from "./YioksEmpty.vue?vue&type=template&id=75363ebd&scoped=true&"
import script from "./YioksEmpty.vue?vue&type=script&lang=js&"
export * from "./YioksEmpty.vue?vue&type=script&lang=js&"
import style0 from "./YioksEmpty.vue?vue&type=style&index=0&id=75363ebd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75363ebd",
  null
  
)

export default component.exports